import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Internal link block. Strengthens the link graph for SEO and
 * helps users move Home → Practice → Test-Lab → SAT/AP naturally.
 * Pass an array of { to, title, desc } items.
 */
export default function RelatedLinks({ title = "Continue your journey", items = [] }) {
  if (!items.length) return null;
  return (
    <section className="container-spark py-16" aria-label="Related sections">
      <h2 className="text-2xl sm:text-3xl font-bold">{title}</h2>
      <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((i) => (
          <Link
            key={i.to}
            to={i.to}
            className="card-spark p-6 hover:-translate-y-1 transition flex items-start justify-between gap-3"
            data-testid={`related-${i.to.replace(/\//g, "-")}`}
          >
            <div>
              <div className="font-bold">{i.title}</div>
              <div className="mt-1 text-sm text-muted-foreground">{i.desc}</div>
            </div>
            <ArrowRight className="mt-1 shrink-0 text-spark-purple" size={18} />
          </Link>
        ))}
      </div>
    </section>
  );
}
